'use client'; // Error boundaries must be Client Components

import { GeneralError } from '@pioz/mlm-skeleton';

interface ErrorProp extends Error {
  digest?: string;
}

export default function GlobalError({ error, reset }: { error: ErrorProp; reset: () => void }) {
  return (
    // global-error must include html and body tags
    <html>
      <body>
        <GeneralError error={error} reset={reset} />
      </body>
    </html>
  );
}
